<template>
  <nx-content-wizard
    ref="wizard"
    type="audio"
    :active="active"
    @dismiss="onDismiss"
    @entityCreated="entityCreated"
  >
    <template slot="toolbar">
      <v-btn
        :loading="loading"
        @click="create"
        color="accent"
        dark
        flat
        :disabled="!validForm||loading"
      >{{ $t('message.wizard.createBtn') }}</v-btn>
    </template>
    <nx-file-uploader
      :label="$t('message.wizard.content.chooseAudio')"
      :selectedFileName="draft.selectedFileName"
      @file="onSelectedFile"
      @dismiss="clearFiles"
      extensions="audio/*,.mp3"
      ref="upload"
    ></nx-file-uploader>
  </nx-content-wizard>
</template>

<script>
/**
 * @TODO Unificar WizardAudio y WizardVideo cuando refactorizemos las subidas del CMS usando multipart
 */
import Wizard from '@/modules/content/wizard/ContentWizard';
import FileUploader from '@/modules/upload/FileUploader';
import api from '@/modules/content/wizard/api';
import { mapGetters } from 'vuex';

export default {
  name: 'nx-content-audio-wizard',
  components: {
    [Wizard.name]: Wizard,
    [FileUploader.name]: FileUploader,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      loading: false,
      flags: {},
      draft: {
        title: '',
        mainTaxonomyId: null,
        selectedFileName: '',
        selectedFile: null,
      },
    };
  },
  computed: {
    ...mapGetters(['context']),
    validForm() {
      return (!!this.draft.selectedFile
        && !!this.$refs.wizard.draft.mainTaxonomyId
        && !!this.$refs.wizard.draft.title
      );
    },
  },
  methods: {
    async create() {
      this.loading = true;
      // Crea el fichero en el back
      const fileUpload = await this.$store.dispatch(
        'upload/UPLOAD_WITH_PRESIGNED_URL', {
          file: this.draft.selectedFile,
          type: 'contentAudioFile',
        },
      );
      // Añadimos el fileId en el draft del wizard
      // para incluir el Id del fichero que acabamos de crear en el
      // payload que usamos para la petición "create"
      this.$refs.wizard.draft.fileId = fileUpload.fileId;
      // Video create payload
      const creationData = this.$refs.wizard.creationData();
      const type = this.$refs.wizard.type;
      // Petición para crear el vídeo

      const response = await api.create(creationData, type);
      // Redirigimos al editor del contenido Video
      this.$router.push({
        name: 'content.editor',
        params: {
          type: 'audio',
          id: response.id,
        },
      });

      // response.id representa el id del vídeo
      fileUpload.contentId = response.id;
      fileUpload.type = 'audio';

      await fileUpload.uploadAllParts();
      await fileUpload.completeUpload();
      this.$store.commit('upload/COMPLETE_FILE_UPLOAD', fileUpload);
    },
    onDismiss() {
      // invocamos el método clearFiles del componente FileUploader
      this.$emit('dismiss');
    },
    clearFiles() {
      this.$refs.upload.clearFiles();
      this.draft.selectedFile = null;
      this.draft.selectedFileName = '';
    },
    onLoad(state) {
      this.loading = state;
    },
    entityCreated(entity) {
      this.$emit('entityCreated', entity);
    },
    onSelectedFile(file) {
      this.draft.selectedFile = file;
      this.draft.selectedFileName = file.name;
    },
  },
};
</script>
